import { useState, useEffect } from "react";
import "../../../assets/css/loan.css";
import TableControls from "../../../components/TableControls";
import BaseModal from "../../../components/BaseModal";

import { useAuth } from "../../../context/AuthContext";

import { useToast } from "../../../context/ToastContext";

const FILE_BASE = process.env.REACT_APP_API_BASE;
console.log("LoanApplications loaded");

const API_BASE = process.env.REACT_APP_API_BASE + "/loans/loans.php";

const LOAN_SETTINGS_API =
  process.env.REACT_APP_API_BASE + "/loans/loan_settings.php";

console.log("API_BASE:", process.env.REACT_APP_API_BASE);
console.log("Full URL:", API_BASE);



export default function LoanApplications() {    
  
const { user } = useAuth();
const { showToast } = useToast();
  const [loanList, setLoanList] = useState([]);
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [loading, setLoading] = useState(true);
  
  const [initialLoading, setInitialLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
const [actionModal, setActionModal] = useState(null);
const [comment, setComment] = useState("");

const [selectedDocs, setSelectedDocs] = useState([]);

const [selectedFields, setSelectedFields] = useState([]);
const [returnTo, setReturnTo] = useState("rm");

  const [previewDoc, setPreviewDoc] = useState(null);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [approvedAmount, setApprovedAmount] = useState("");

  const [editModal, setEditModal] = useState(false);
const [editForm, setEditForm] = useState({});

  const [loanSettings, setLoanSettings] = useState(null);


  const [payslipModalOpen, setPayslipModalOpen] = useState(false);
const [payslipData, setPayslipData] = useState(null);
const [payslipLoading, setPayslipLoading] = useState(false);

  const normalizeList = (value) => {
  let list = [];

  if (Array.isArray(value)) {
    list = value;
  } else if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      list = Array.isArray(parsed) ? parsed : [];
    } catch {
      list = value.split(",");
    }
  }

  return list.map(normalizeText).filter(Boolean);
};

const normalizeText = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");

const userDesignation = normalizeText(user?.designation);
const userRole = normalizeText(user?.role);
const levelOneDesignations = normalizeList(
  loanSettings?.level_one_designations
);

const levelTwoDesignations = normalizeList(
  loanSettings?.level_two_designations
);

const levelOneRoles = normalizeList(
  loanSettings?.level_one_roles
);

const levelTwoRoles = normalizeList(
  loanSettings?.level_two_roles
);

const isLevelOneApprover =
  levelOneDesignations.includes(userDesignation) ||
  levelOneRoles.includes(userRole);

const isLevelTwoApprover =
  levelTwoDesignations.includes(userDesignation) ||
  levelTwoRoles.includes(userRole);

  const [searchTerm, setSearchTerm] = useState("");
const [statusFilter, setStatusFilter] = useState("all");
const [productFilter, setProductFilter] = useState("all");
  const startIndex = (currentPage - 1) * rowsPerPage;
 const safeLoanList = Array.isArray(loanList) ? loanList : [];

 const isTopUpLoan = (loan) =>
  loan?.application_type === "LIQUIDATION_TOPUP";


 const selectedEditProduct = (loanSettings?.products || []).find(
  (p) => p.product_name === editForm.loan_product
);

const getTenorOptions = (product) => {
  if (!product) return [];

  const min = Number(product.min_tenure || 0);
  const max = Number(product.max_tenure || 0);

  return Array.from({ length: max - min + 1 }, (_, i) => min + i);
};


// ✅ AUTO PREFILL APPROVED AMOUNT WHEN APPROVE MODAL OPENS
useEffect(() => {
if (actionModal?.type === "approve" && actionModal.loan?.loan_amount) {
  setApprovedAmount(actionModal.loan.loan_amount);
}
}, [actionModal]);
// ================= FILTERING =================
const filteredLoans = safeLoanList.filter((loan) => {
 const fullName = (
  loan.customer_name ||
  `${loan.first_name || ""} ${loan.last_name || ""}`
).toLowerCase();

  const matchesSearch =
    fullName.includes(searchTerm.toLowerCase()) ||
    (loan.loan_product || "")
      .toLowerCase()
      .includes(searchTerm.toLowerCase());

const matchesStatus =
  statusFilter === "all" ||
  (statusFilter === "approved" &&
    (loan.status === "approved" || loan.status === "level_one_approved")) ||
  loan.status === statusFilter;

  const matchesProduct =
    productFilter === "all" ||
    loan.loan_product === productFilter;

  return matchesSearch && matchesStatus && matchesProduct;
});

// Reset to page 1 when filters change
useEffect(() => {
  setCurrentPage(1);
}, [searchTerm, statusFilter, productFilter]);
const paginatedLoans = filteredLoans.slice(
  startIndex,
  startIndex + rowsPerPage
);
const documents = [
  { key: "passport", label: "Passport Photograph", icon: "🖼️" },
  { key: "id_card", label: "Official Identification Card", icon: "🪪" },
  { key: "payslip", label: "Last Month Payslip", icon: "📑" },
  { key: "bank_statement", label: "Bank Statement", icon: "🏦" },
  { key: "consent_form", label: "Signed Consent Form", icon: "📄" }, // ✅ ADD THIS
  { key: "asset_photo", label: "Asset Photo", icon: "📸" },
  { key: "business_docs", label: "Business Documents", icon: "📁" },
  { key: "signature", label: "Signature", icon: "✍️" },
];

const returnableFields = [
  { key: "bvn", label: "BVN" },
  { key: "nin", label: "NIN" },
  { key: "phone", label: "Phone Number" },
  { key: "email", label: "Email Address" },
  { key: "bank_name", label: "Bank Name" },
  { key: "account_number", label: "Account Number" },
  { key: "loan_amount", label: "Loan Amount" },
  { key: "loan_product", label: "Loan Product" },
  { key: "loan_tenor", label: "Loan Tenor" },
];

const approverEditableFields = [
  { key: "bvn", label: "BVN" },
  { key: "nin", label: "NIN" },
  { key: "phone", label: "Phone Number" },
  { key: "email", label: "Email Address" },
  { key: "bank_name", label: "Bank Name" },
  { key: "account_number", label: "Account Number" },

  { key: "ippis_number", label: "IPPIS Number" },

  { key: "loan_amount", label: "Loan Amount" },
  { key: "loan_product", label: "Loan Product" },
  { key: "loan_tenor", label: "Loan Tenor" },
];

const toggleDoc = (docKey) => {
  setSelectedDocs((prev) =>
    prev.includes(docKey)
      ? prev.filter((d) => d !== docKey)
      : [...prev, docKey]
  );
};

const toggleField = (fieldKey) => {
  setSelectedFields((prev) =>
    prev.includes(fieldKey)
      ? prev.filter((f) => f !== fieldKey)
      : [...prev, fieldKey]
  );
};


const handleViewPayslip = async () => {
  if (!selectedLoan?.ippis_number) {
    showToast("error", "Missing IPPIS", "This customer has no IPPIS number.");
    return;
  }

  try {
    setPayslipLoading(true);
    setPayslipData(null);

    const res = await fetch(`${FILE_BASE}/loans/check_customer_payslip.php`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ippis: selectedLoan.ippis_number,
      }),
    });

    const data = await res.json();

    if (!res.ok || !data.success) {
      throw new Error(data.message || "Payslip not found.");
    }

    setPayslipData(data);
    setPayslipModalOpen(true);
  } catch (error) {
    showToast("error", "Payslip Not Found", error.message);
  } finally {
    setPayslipLoading(false);
  }
};


const handleConfirmAction = async () => {
  if (!actionModal) return;

  // ================= BASIC VALIDATION =================

  if (actionModal.type === "reject" && !comment.trim()) {
    showToast("error", "Comment Required", "Please provide a reason.");
    return;
  }

  if (actionModal.type === "return") {
  if (!comment.trim()) {
    showToast("error", "Comment Required", "Please provide a reason.");
    return;
  }
}


  try {
    setActionLoading(true);

    let newStatus = "";

    // ================= APPROVE =================
    if (actionModal.type === "approve") {

      // Validate approved amount
      if (!approvedAmount || Number(approvedAmount) <= 0) {
        showToast("error", "Invalid Amount", "Enter a valid approved amount.");
        setActionLoading(false);
        return;
      }

      if (Number(approvedAmount) > Number(actionModal.loan.loan_amount)) {
        showToast("error", "Invalid Amount", "Approved amount cannot exceed requested amount.");
        setActionLoading(false);
        return;
      }

      // Determine approval level
     const approvalEnabled = Number(loanSettings?.approval_enabled) === 1;
const approvalLevels = Number(loanSettings?.approval_levels || 2);

if (!approvalEnabled) {
  newStatus = "approved";
} else if (userRole === "super_admin") {
  newStatus = "approved";
} else if (approvalLevels === 1 && isLevelOneApprover) {
  newStatus = "approved";
} else if (
  approvalLevels === 2 &&
  isLevelOneApprover &&
  actionModal.loan.status === "submitted"
) {
  newStatus = "level_one_approved";
} else if (
  approvalLevels === 2 &&
  isLevelTwoApprover &&
  actionModal.loan.status === "level_one_approved"
) {
  newStatus = "approved";
} else {
  showToast("error", "Not Allowed", "You are not authorized to approve.");
  setActionLoading(false);
  return;
}
    }

    // ================= REJECT =================
    if (actionModal.type === "reject") {
      newStatus = "rejected";
    }

    // ================= RETURN =================
    if (actionModal.type === "return") {
      newStatus = "returned";
    }

    if (actionModal.type === "recall") {
  newStatus = "submitted";
}

    // ================= API CALL =================
    const res = await fetch(API_BASE, {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: actionModal.loan.id,
        status: newStatus,
        comment: comment || null,
        approved_amount:
          actionModal.type === "approve"
            ? approvedAmount
            : null,
      documents:
  actionModal.type === "return"
    ? selectedDocs
    : [],

    returned_fields:
  actionModal.type === "return"
    ? selectedFields
    : [],

    return_to:
  actionModal.type === "return"
    ? returnTo
    : null,

      }),
    });

    const result = await res.json();

    if (!res.ok) {
      showToast("error", "Error", result.message);
      setActionLoading(false);
      return;
    }

    showToast("success", "Success", "Loan updated successfully");

   await fetchLoans(false);
   
    // Clean up state
    setTimeout(() => {
      setActionModal(null);
      setSelectedLoan(null);
      setApprovedAmount("");
      setActionLoading(false);
    }, 600);

  } catch (error) {
    console.error(error);
    showToast("error", "Server Error", "Something went wrong");
    setActionLoading(false);
  }
};


const handleSaveFieldUpdates = async () => {
  if (!selectedLoan) return;

  if (
    selectedLoan.status === "approved" ||
    selectedLoan.status === "disbursed"
  ) {
    showToast(
      "error",
      "Not Allowed",
      "Approved or disbursed loans cannot be edited."
    );
    return;
  }

  try {
    setActionLoading(true);

    const changedFields = {};


    const product = (loanSettings?.products || []).find(
  (p) => p.product_name === editForm.loan_product
);

if (product) {
  const amount = Number(editForm.loan_amount || 0);
  const minAmount = Number(product.min_amount || 0);
  const maxAmount = Number(product.max_amount || 0);
  const tenor = Number(editForm.loan_tenor || 0);
  const minTenor = Number(product.min_tenure || 0);
  const maxTenor = Number(product.max_tenure || 0);

  if (amount < minAmount || amount > maxAmount) {
    showToast(
      "error",
      "Invalid Amount",
      `Amount must be between ₦${minAmount.toLocaleString()} and ₦${maxAmount.toLocaleString()} for ${product.product_name}.`
    );
    setActionLoading(false);
    return;
  }

  if (tenor < minTenor || tenor > maxTenor) {
    showToast(
      "error",
      "Invalid Tenor",
      `Tenor must be between ${minTenor} and ${maxTenor} months for ${product.product_name}.`
    );
    setActionLoading(false);
    return;
  }
}


    Object.keys(editForm).forEach((key) => {
      const oldValue = String(selectedLoan[key] || "").trim();
      const newValue = String(editForm[key] || "").trim();

      if (oldValue !== newValue) {
        changedFields[key] = editForm[key];
      }
    });

    if (Object.keys(changedFields).length === 0) {
      showToast(
        "info",
        "No Changes",
        "No field was updated."
      );
      setActionLoading(false);
      return;
    }

    const res = await fetch(API_BASE, {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: selectedLoan.id,
        status: selectedLoan.status,
        field_updates: changedFields,
      }),
    });

    const result = await res.json();

    if (!res.ok) {
      showToast(
        "error",
        "Error",
        result.message || "Failed to save changes"
      );
      setActionLoading(false);
      return;
    }

    showToast(
      "success",
      "Updated",
      "Fields updated successfully"
    );

    await fetchLoans(false);

    setSelectedLoan((prev) => ({
      ...prev,
      ...changedFields,
    }));

    setEditModal(false);
    setActionLoading(false);

  } catch (error) {
    console.error(error);

    showToast(
      "error",
      "Server Error",
      "Failed to save changes"
    );

    setActionLoading(false);
  }
};

const fetchLoanSettings = async () => {
  try {
    const res = await fetch(LOAN_SETTINGS_API, {
      credentials: "include",
    });

    const result = await res.json();

  if (res.ok && result.success) {
  const approvers = Array.isArray(result.approvers) ? result.approvers : [];

setLoanSettings({
  ...result.settings,
  products: Array.isArray(result.products) ? result.products : [],
  level_one_designations: approvers
  .filter((a) => Number(a.level) === 1)
  .map((a) => normalizeText(a.approver_name)),

   level_two_designations: approvers
  .filter((a) => Number(a.level) === 2)
  .map((a) => normalizeText(a.approver_name)),
  });
}
  } catch (error) {
    console.error("Failed to load loan settings:", error);
  }
};

  /* ================= FETCH ================= */
const fetchLoans = async (showLoader = false) => {
  try {
if (showLoader) {
  setLoading(true);
}
   const res = await fetch(API_BASE, {
  credentials: "include",
});

if (res.status === 401) {
  showToast("error", "Session Expired", "Please login again.");
  setLoading(false);
  return;
}

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.message || "Failed to fetch loans");
    }

    const response = await res.json();

    console.log("API RAW RESPONSE:", response);

    // 🔥 FORCE ARRAY SAFETY
    const data = Array.isArray(response)
      ? response
      : Array.isArray(response?.data)
      ? response.data
      : [];

   let filteredLoans = data;

if (user?.is_approver) {
  if (isLevelOneApprover) {
    filteredLoans = data.filter(
      (loan) =>
        loan.status === "submitted" ||
        loan.status === "returned" ||
        loan.status === "rejected"
    );
  }

  if (isLevelTwoApprover) {
    filteredLoans = data.filter(
      (loan) =>
        loan.status === "level_one_approved" ||
        loan.status === "returned" ||
        loan.status === "rejected"
    );
  }
}
    const statusOrder = {
      submitted: 1,
      level_one_approved: 2,
      returned: 3,
      approved: 4,
      rejected: 5,
    };

    const sorted = [...filteredLoans].sort(
      (a, b) =>
        (statusOrder[a.status] || 99) -
        (statusOrder[b.status] || 99)
    );

  setLoanList((prevLoans) => {
  const prev = JSON.stringify(prevLoans);
  const next = JSON.stringify(sorted);

  if (prev !== next) {
    return sorted;
  }

  return prevLoans;
});
  } catch (error) {
    console.error("Fetch loans error:", error);
    showToast("error", "Error", error.message || "Failed to load loans");
    setLoanList([]); // 🔥 ALWAYS RESET TO ARRAY
} finally {
  setLoading(false);
  setInitialLoading(false);
}
  };


useEffect(() => {
  if (!user) return;

 fetchLoanSettings();
fetchLoans(true);

  const interval = setInterval(() => {
    fetchLoans(false);
  }, 15000);

  return () => clearInterval(interval);
}, [user]);

  return (
    <div className="staff-page">
      
      {initialLoading ? (
  <div className="loan-page-loader">
    <div className="loan-page-spinner"></div>
    <h4>Loading Loan Applications</h4>
    <p>Please wait while we fetch pending applications...</p>
  </div>
) : (
  <>

      <div className="page-header">
        <div className="page-header-left">
          <h2 className="page-title">Loan Applications</h2>
          <p className="page-subtitle">
            Review newly submitted loan applications
          </p>
        </div>
      </div>

      <div className="card">

   <div className="loan-table-header">

  <div className="loan-table-left">
    <div className="search-wrapper">
      <input
        type="text"
        placeholder="Search applicant or product..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  </div>

  <div className="loan-table-right">
    <select
      value={statusFilter}
      onChange={(e) => setStatusFilter(e.target.value)}
    >
     <option value="all">All Status</option>
<option value="submitted">Submitted</option>
<option value="level_one_approved">Level 1 Approved</option>
<option value="approved">Final Approved</option>
<option value="returned">Returned</option>
<option value="rejected">Rejected</option>
<option value="disbursed">Disbursed</option>
    </select>

    <select
      value={productFilter}
      onChange={(e) => setProductFilter(e.target.value)}
    >
      <option value="all">All Products</option>
      <option value="IPPIS">IPPIS</option>
      <option value="SME">SME</option>
      <option value="ASSET">ASSET</option>
    </select>

    {/* CLEAR BUTTON */}
    <button
      className="filter-clear-btn"
      onClick={() => {
        setSearchTerm("");
        setStatusFilter("all");
        setProductFilter("all");
      }}
    >
      Clear
    </button>
  </div>

</div>




      <TableControls
  totalItems={filteredLoans.length}
  currentPage={currentPage}
  rowsPerPage={rowsPerPage}
  onPageChange={setCurrentPage}
  onRowsPerPageChange={setRowsPerPage}
/>

      <div className="table-wrapper">
  <table>
              <thead>
                <tr>
                     <th>No.</th>
                  <th>Applicant</th>
                <th>Product</th>
<th>Type</th>
<th>Amount</th>
                  <th>Tenor</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
<tbody>
  {/* ================= LOADING STATE ================= */}
{paginatedLoans.length === 0 ? (
    /* ================= EMPTY STATE ================= */
    <tr>
      <td colSpan="9" className="no-data-cell">
      No loan applications found.
      </td>
    </tr>
  ) : (
    /* ================= DATA ================= */
    paginatedLoans.map((loan, index) => (
      <tr key={loan.id}>
        
        <td>{startIndex + index + 1}</td>

       <td>
  {isTopUpLoan(loan)
    ? loan.customer_name || `${loan.first_name || ""} ${loan.last_name || ""}`
    : `${loan.first_name || ""} ${loan.last_name || ""}`}
</td>

        {/* ✅ FIXED PRODUCT */}
     <td>
  {loan.loan_product || "-"}
</td>

<td>
  <span
    className={`loan-type-badge ${
      isTopUpLoan(loan)
        ? "loan-type-topup"
        : "loan-type-fresh"
    }`}
  >
    {isTopUpLoan(loan)
      ? "Top-up"
      : "Fresh"}
  </span>
</td>

<td>
  {loan.loan_amount
            ? `₦${Number(loan.loan_amount).toLocaleString()}`
            : "-"}
        </td>

        {/* ✅ FIXED TENOR */}
        <td>
          {loan.loan_tenor
            ? `${loan.loan_tenor} months`
            : "-"}
        </td>

        <td>
          <span
            className={`badge ${
              loan.status === "approved"
                ? "badge-success"
                : loan.status === "rejected"
                ? "badge-danger"
                : loan.status === "returned"
                ? "badge-secondary"
                : loan.status === "level_one_approved"
                ? "badge-info"
                : loan.status === "disbursed"
                ? "badge-primary"
                : "badge-warning"
            }`}
          >
            {loan.status === "level_one_approved"
              ? "Level 1 Approved"
              : loan.status === "approved"
              ? "Final Approved"
              : loan.status === "submitted"
              ? "Submitted"
              : loan.status === "reviewing"
              ? "Under Review"
              : loan.status}
          </span>
        </td>

        <td>
          {loan.created_at
            ? new Date(loan.created_at).toLocaleDateString()
            : "-"}
        </td>

       <td>
  <button
    className="action-btn"
    onClick={() => setSelectedLoan(loan)}
  >
    Review
  </button>
</td>
      </tr>
    ))
  )}
</tbody>


        </table>
          </div>
        
      </div>

      {/* ================= ADVANCED MODAL ================= */}
    <BaseModal
  isOpen={!!selectedLoan}
  title="Loan Application Details"
  onClose={() => setSelectedLoan(null)}
  size="lg"
>
  {selectedLoan && (
    <div className="loan-details-grid">

      {/* ================= APPLICANT ================= */}
     <div className="loan-section">
  <h4>Applicant Information</h4>

  <div className="loan-info-grid">

    {/* ✅ NEW CUSTOMER NAME */}
   <div className="loan-info-item">
      <span className="loan-info-label">Customer Name</span>
      <span className="loan-info-value">
        {selectedLoan.customer_name ||
          `${selectedLoan.first_name} ${selectedLoan.last_name}`}
      </span>
    </div>

   <div className="loan-info-item">
  <span className="loan-info-label">Product</span>
  <span className="loan-info-value">
    {selectedLoan.loan_product || "-"}
  </span>
</div>

<div className="loan-info-item">
  <span className="loan-info-label">Application Type</span>
  <span className="loan-info-value">
    {isTopUpLoan(selectedLoan)
      ? "Top-up / Liquidation"
      : "Fresh Loan"}
  </span>
</div>

<div className="loan-info-item">
  <span className="loan-info-label">Amount</span>
      <span className="loan-info-value">
        ₦{Number(selectedLoan.loan_amount || 0).toLocaleString()}
      </span>
    </div>

    <div className="loan-info-item">
      <span className="loan-info-label">Tenor</span>
      <span className="loan-info-value">
        {selectedLoan.loan_tenor
          ? `${selectedLoan.loan_tenor} months`
          : "-"}
      </span>
    </div>


    <div className="loan-info-item">
  <span className="loan-info-label">Bank Name</span>
  <span className="loan-info-value">
    {selectedLoan.bank_name || "-"}
  </span>
</div>

<div className="loan-info-item">
  <span className="loan-info-label">Account Number</span>
  <span className="loan-info-value">
    {selectedLoan.account_number || "-"}
  </span>
</div>

    <div className="loan-info-item">
      <span className="loan-info-label">Status</span>
      <span className="loan-info-value">
        {selectedLoan.status}
      </span>
    </div>

  </div>
</div>




      {/* ================= EMPLOYMENT ================= */}
      <div className="loan-section">
        <h4>Employment Details</h4>

        <div className="loan-info-grid">
          <div className="loan-info-item">
            <span className="loan-info-label">Employer</span>
            <span className="loan-info-value">{selectedLoan.employer}</span>
          </div>

          <div className="loan-info-item">
            <span className="loan-info-label">Grade Level</span>
            <span className="loan-info-value">{selectedLoan.grade_level}</span>
          </div>

           <div className="loan-info-item">
    <span className="loan-info-label">IPPIS Number</span>
    <span className="loan-info-value">
      {selectedLoan.ippis_number || "-"}
    </span>
  </div>


  <div className="loan-info-item">
  <span className="loan-info-label">Customer Payslip</span>
  <span className="loan-info-value">
    <button
      type="button"
      className="view-payslip-link"
      onClick={handleViewPayslip}
      disabled={payslipLoading}
    >
      {payslipLoading ? "Loading..." : "View Payslip"}
    </button>
  </span>
</div>


          <div className="loan-info-item">
            <span className="loan-info-label">Date of Employment</span>
            <span className="loan-info-value">
              {selectedLoan.date_of_employment}
            </span>
          </div>
        </div>
      </div>


{isTopUpLoan(selectedLoan) && (
  <div className="loan-section topup-section">
    <h4>Top-up / Liquidation Details</h4>

    <div className="loan-info-grid">
      <div className="loan-info-item">
        <span className="loan-info-label">Existing Loan ID</span>
        <span className="loan-info-value">
          {selectedLoan.existing_loan_id || "-"}
        </span>
      </div>

      <div className="loan-info-item">
        <span className="loan-info-label">Existing Loan Account</span>
        <span className="loan-info-value">
          {selectedLoan.existing_loan_account || "-"}
        </span>
      </div>

      <div className="loan-info-item">
        <span className="loan-info-label">Outstanding Principal</span>
        <span className="loan-info-value">
          ₦{Number(selectedLoan.outstanding_principal || 0).toLocaleString()}
        </span>
      </div>

      <div className="loan-info-item">
        <span className="loan-info-label">One Month Interest</span>
        <span className="loan-info-value">
          ₦{Number(selectedLoan.one_month_interest || 0).toLocaleString()}
        </span>
      </div>

      <div className="loan-info-item">
        <span className="loan-info-label">Liquidation Fee</span>
        <span className="loan-info-value">
          ₦{Number(selectedLoan.liquidation_fee || 0).toLocaleString()}
        </span>
      </div>

      <div className="loan-info-item">
        <span className="loan-info-label">Total Principal to Settle</span>
        <span className="loan-info-value">
          ₦{Number(selectedLoan.total_principal_to_settle || 0).toLocaleString()}
        </span>
      </div>

      <div className="loan-info-item full-width">
        <span className="loan-info-label">Estimated Amount Customer Will Receive</span>
        <span className="loan-info-value">
          ₦{Number(selectedLoan.estimated_disbursement || 0).toLocaleString()}
        </span>
      </div>
    </div>
  </div>
)}




      {/* ================= PERSONAL DETAILS ================= */}
<div className="loan-section">
  <h4>Personal Details</h4>

  <div className="loan-info-grid">

    <div className="loan-info-item">
      <span className="loan-info-label">BVN</span>
      <span className="loan-info-value">
        {selectedLoan.bvn || "-"}
      </span>
    </div>

    <div className="loan-info-item">
      <span className="loan-info-label">NIN</span>
      <span className="loan-info-value">
        {selectedLoan.nin || "-"}
      </span>
    </div>

    <div className="loan-info-item">
      <span className="loan-info-label">Date of Birth</span>
      <span className="loan-info-value">
        {selectedLoan.dob || "-"}
      </span>
    </div>

    <div className="loan-info-item">
      <span className="loan-info-label">Phone</span>
      <span className="loan-info-value">
        {selectedLoan.phone || "-"}
      </span>
    </div>

    <div className="loan-info-item">
      <span className="loan-info-label">Email</span>
      <span className="loan-info-value">
        {selectedLoan.email || "-"}
      </span>
    </div>

    <div className="loan-info-item full-width">
      <span className="loan-info-label">Address</span>
      <span className="loan-info-value">
        {selectedLoan.address || "-"}
      </span>
    </div>

    <div className="loan-info-item">
      <span className="loan-info-label">State of Origin</span>
      <span className="loan-info-value">
        {selectedLoan.state_of_origin || "-"}
      </span>
    </div>

  </div>
</div>


{/* ================= NEXT OF KIN ================= */}
<div className="loan-section">
  <h4>Next of Kin</h4>

  <div className="loan-info-grid">
    <div className="loan-info-item">
      <span className="loan-info-label">Name</span>
      <span className="loan-info-value">
        {selectedLoan.next_of_kin || "-"}
      </span>
    </div>

    <div className="loan-info-item">
      <span className="loan-info-label">Phone</span>
      <span className="loan-info-value">
        {selectedLoan.nok_phone || "-"}
      </span>
    </div>
  </div>
</div>

{selectedLoan.business_name && (
  <div className="loan-section">
    <h4>Business Details</h4>

    <div className="loan-info-grid">

      <div className="loan-info-item">
        <span className="loan-info-label">Business Name</span>
        <span className="loan-info-value">
          {selectedLoan.business_name}
        </span>
      </div>

      <div className="loan-info-item">
        <span className="loan-info-label">RC Number</span>
        <span className="loan-info-value">
          {selectedLoan.rc_number || "-"}
        </span>
      </div>

      <div className="loan-info-item full-width">
        <span className="loan-info-label">Business Address</span>
        <span className="loan-info-value">
          {selectedLoan.business_address || "-"}
        </span>
      </div>

    </div>
  </div>
)}

      {/* ================= RELATIONSHIP MANAGER ================= */}
{(selectedLoan.rm_name || selectedLoan.rm_email) && (
  <div className="loan-section">
    <h4>Relationship Manager</h4>

    <div className="loan-info-grid">
      <div className="loan-info-item">
        <span className="loan-info-label">RM Name</span>
        <span className="loan-info-value">
          {selectedLoan.rm_name || "-"}
        </span>
      </div>

      <div className="loan-info-item">
        <span className="loan-info-label">RM Email</span>
        <span className="loan-info-value">
          {selectedLoan.rm_email || "-"}
        </span>
      </div>

      <div className="loan-info-item">
        <span className="loan-info-label">RM Code</span>
        <span className="loan-info-value">
          {selectedLoan.rm_code || "-"}
        </span>
      </div>
    </div>
  </div>
)}

      {/* ================= DOCUMENTS ================= */}
{/* ================= DOCUMENTS ================= */}
<div className="loan-section">
  <h4>Supporting Documents</h4>

  <div className="doc-grid">
    {documents.map((doc) =>
      selectedLoan?.[doc.key] ? (
        <div
          key={doc.key}
          className="doc-card"
          onClick={() =>
            setPreviewDoc(`${FILE_BASE}/${selectedLoan[doc.key]}`)
          }
          style={{ cursor: "pointer" }}
        >
          <div className="doc-icon">{doc.icon}</div>

          <div className="doc-info">
            <span className="doc-title">{doc.label}</span>
            <span className="doc-sub">
              Click to view document
            </span>
          </div>
        </div>
      ) : null
    )}
  </div>
</div>

{previewDoc && (
  <div className="doc-preview-overlay">
    <div className="doc-preview-header">
      <h4>Document Preview</h4>

      <button
        className="doc-preview-close"
        onClick={() => setPreviewDoc(null)}
      >
        ✕
      </button>
    </div>

    <div className="doc-preview-body">
      <iframe
        src={previewDoc}
        title="Document Preview"
        frameBorder="0"
      />
    </div>
  </div>
)}

{/* ================= FULL APPLICATION HISTORY ================= */}
{selectedLoan.history && selectedLoan.history.length > 0 && (
  <div className="loan-section">
    <h4>Application History</h4>

    <div className="history-timeline">
      {selectedLoan.history.map((item, index) => {
        const statusLabel = item.action
          ?.replaceAll("_", " ")
          .toUpperCase();

        const badgeClass =
          item.action === "approved"
            ? "badge-success"
            : item.action === "rejected"
            ? "badge-danger"
            : item.action === "returned"
            ? "badge-secondary"
            : item.action === "level_one_approved"
            ? "badge-info"
            : item.action === "resubmitted"
            ? "badge-warning"
            : "badge-primary";

        return (
          <div key={index} className="history-item">

            {/* STATUS BADGE */}
            <div className="history-status">
              <span className={`history-badge ${badgeClass}`}>
                {statusLabel}
              </span>
            </div>

            {/* COMMENT */}
       {item.comment && (
  <div
    className={`history-comment ${
      item.action === "resubmitted" ? "rm-comment" : "admin-comment"
    }`}
  >
    <strong>
      {item.action === "resubmitted"
        ? "RM Response:"
        : "Admin Comment:"}
    </strong>{" "}
    {item.comment}
  </div>
)}

            {/* META INFO */}
            <div className="history-meta">
              <small>
                {new Date(item.created_at).toLocaleString()}
                {" • "}
                <strong>
                  {item.action_by_name?.trim() || "Unknown User"}
                </strong>
              </small>
            </div>

          </div>
        );
      })}
    </div>
  </div>
)}



{/* ================= ACTIONS ================= */}
{(() => {
  const canApprove = true;
  return canApprove;
})() && (
  <div className="modal-actions">

{selectedLoan.status !== "approved" &&
 selectedLoan.status !== "disbursed" && (
  <button
    className="btn-outline"
    onClick={() => {
      setEditForm({
        bvn: selectedLoan.bvn || "",
        nin: selectedLoan.nin || "",
        phone: selectedLoan.phone || "",
        email: selectedLoan.email || "",
        bank_name: selectedLoan.bank_name || "",
        account_number: selectedLoan.account_number || "",
        ippis_number: selectedLoan.ippis_number || "",
        loan_amount: selectedLoan.loan_amount || "",
        loan_product: selectedLoan.loan_product || "",
        loan_tenor: selectedLoan.loan_tenor || "",
      });

      setEditModal(true);
    }}
  >
    Edit Fields
  </button>
)}

  

   {selectedLoan.status === "approved" || selectedLoan.status === "disbursed" ? (
  <>
    {selectedLoan?.schedule && selectedLoan.schedule.length > 0 && (
      <button
        className="btn-primary"
        onClick={() => setScheduleModal(true)}
      >
        View Schedule
      </button>
    )}

   
  </>
) : ["returned", "rejected"].includes(selectedLoan.status) ? (
  <button
    className="btn-primary"
    onClick={() => {
      setComment("");
      setActionModal({
        type: "recall",
        loan: selectedLoan,
      });
    }}
  >
    Recall Application
  </button>
) : (
  <>
    <button
      className="btn-outline"
   onClick={() => {
  setComment("");
  setSelectedDocs([]);
  setSelectedFields([]);
  setReturnTo("rm");

  setActionModal({
    type: "return",
    loan: selectedLoan,
  });
}}
    >
      Return
    </button>

    <button
      className="btn-danger"
      onClick={() => {
        setComment("");
        setActionModal({
          type: "reject",
          loan: selectedLoan,
        });
      }}
    >
      Reject
    </button>

    <button
      className="btn-success"
      onClick={() => {
        setComment("");
        setActionModal({
          type: "approve",
          loan: selectedLoan,
        });
      }}
    >
      Approve
    </button>
  </>
)}



  </div>
)}

    </div>
  )}
</BaseModal>


<BaseModal
  isOpen={!!actionModal}
title={
  actionModal?.type === "approve"
    ? "Confirm Approval"
    : actionModal?.type === "reject"
    ? "Confirm Rejection"
    : actionModal?.type === "recall"
    ? "Recall Application"
    : returnTo === "customer"
    ? "Return To Customer"
    : "Return To Relationship Manager"
}

  onClose={() => setActionModal(null)}
  size="lg"
  showClose={false}   // ✅ CORRECT PROP NAME
>


  {actionModal && (
  <div className="confirm-modal">

    {/* ================= APPROVE ================= */}
   {actionModal.type === "approve" && (
  <div className="approve-section">

    <div className="approve-row">
      <span>Applicant</span>
     <strong>
  {isTopUpLoan(actionModal.loan)
    ? actionModal.loan.customer_name || `${actionModal.loan.first_name || ""} ${actionModal.loan.last_name || ""}`
    : `${actionModal.loan.first_name || ""} ${actionModal.loan.last_name || ""}`}
</strong>
    </div>

    <div className="approve-row">
      <span>Product</span>
      <strong>
        {actionModal.loan.loan_product || "-"}
      </strong>
    </div>

    <div className="approve-row">
  <span>Application Type</span>
  <strong>
    {isTopUpLoan(actionModal.loan)
      ? "Top-up / Liquidation"
      : "Fresh Loan"}
  </strong>
</div>

    <div className="approve-row">
      <span>Requested Amount</span>
      <strong>
        ₦{Number(actionModal.loan.loan_amount || 0).toLocaleString()}
      </strong>
    </div>

    {isTopUpLoan(actionModal.loan) && (
  <>
    <div className="approve-row">
      <span>Total Settlement</span>
      <strong>
        ₦{Number(actionModal.loan.total_principal_to_settle || 0).toLocaleString()}
      </strong>
    </div>

    <div className="approve-row">
      <span>Customer Receives</span>
    <strong className="receive-amount">
  ₦{Number(actionModal.loan.estimated_disbursement || 0).toLocaleString()}
</strong>
    </div>
  </>
)}

    <div className="approve-input-group">
      <label>Approved Amount</label>
      <input
        type="number"
        className="approve-input"
        value={approvedAmount}
        disabled={actionLoading}
        onChange={(e) => setApprovedAmount(e.target.value)}
      />
    </div>

    {/* NEW COMMENT FIELD */}
    <div className="approve-input-group">
      <label>Comment</label>
      <textarea
        className="confirm-textarea"
        placeholder="Optional approval comment..."
        value={comment}
        disabled={actionLoading}
        onChange={(e) => setComment(e.target.value)}
      />
    </div>

  </div>
)}

    {/* ================= REJECT ================= */}
    {actionModal.type === "reject" && (
      <>
        <p className="confirm-text">
          Please provide a reason for rejecting this application.
        </p>

     <textarea
  className="confirm-textarea"
  placeholder="Enter reason..."
  value={comment}
  disabled={actionLoading}
  onChange={(e) => setComment(e.target.value)}
/>
      </>
    )}

    {/* ================= RETURN ================= */}
    {actionModal.type === "return" && (
      <>
        <p className="confirm-text">
          Please provide a reason for returning this application.
        </p>

        <div className="approve-input-group">
  <label>Return Application To</label>

  <select
    className="approve-input"
    value={returnTo}
    onChange={(e) => setReturnTo(e.target.value)}
  >
    <option value="rm">
      Relationship Manager
    </option>

    <option value="customer">
      Customer
    </option>
  </select>
</div>

<div className="return-target-info">
  {returnTo === "rm" ? (
    <p>
      Application will be returned to the Relationship Manager for correction and resubmission.
    </p>
  ) : (
    <p>
      Application will be returned directly to the customer. Customer will receive an email notification and secure reply link.
    </p>
  )}
</div>

        <div className="return-doc-grid">
          {documents.map((doc) =>
            selectedLoan?.[doc.key] ? (
              <div
                key={doc.key}
                className={`return-doc-card ${
                  selectedDocs.includes(doc.key) ? "selected" : ""
                }`}
               onClick={() => {
  if (!actionLoading) toggleDoc(doc.key);
}}
              >
              <input
  type="checkbox"
  checked={selectedDocs.includes(doc.key)}
  disabled={actionLoading}
  onChange={() => toggleDoc(doc.key)}
  onClick={(e) => e.stopPropagation()}
/>
                <span>{doc.label}</span>
              </div>
            ) : null
          )}
        </div>


<p className="confirm-text" style={{ marginTop: "14px" }}>
  {returnTo === "customer"
    ? "Select fields the customer can update."
    : "Select fields the Relationship Manager can update."}
</p>

<div className="return-doc-grid">
  {returnableFields.map((field) => (
    <div
      key={field.key}
      className={`return-doc-card ${
        selectedFields.includes(field.key) ? "selected" : ""
      }`}
      onClick={() => {
        if (!actionLoading) toggleField(field.key);
      }}
    >
      <input
        type="checkbox"
        checked={selectedFields.includes(field.key)}
        disabled={actionLoading}
        onChange={() => toggleField(field.key)}
        onClick={(e) => e.stopPropagation()}
      />
      <span>{field.label}</span>
    </div>
  ))}
</div>

      <textarea
  className="confirm-textarea"
  placeholder="Enter reason for return..."
  value={comment}
  disabled={actionLoading}
  onChange={(e) => setComment(e.target.value)}
/>
      </>
    )}

    {/* ================= ACTION BUTTONS ================= */}
    <div className="modal-actions">
    <button
  className="btn-outline"
  disabled={actionLoading}
  onClick={() => {
    setActionModal(null);
    setApprovedAmount("");
  }}
>
        Cancel
      </button>

      <button
        className={
          actionModal.type === "approve"
            ? "btn-success"
            : actionModal.type === "reject"
            ? "btn-danger"
            : "btn-outline"
        }
        onClick={handleConfirmAction}
        disabled={actionLoading}
      >
      {actionLoading ? (
  <span className="btn-spinner"></span>
) : actionModal.type === "return" ? (
  `Return to ${
    returnTo === "customer"
      ? "Customer"
      : "RM"
  }`
) : (
  "Confirm"
)}
      </button>
    </div>

  </div>
)}




</BaseModal>


<BaseModal
  isOpen={editModal}
  title="Edit Application Fields"
  onClose={() => setEditModal(false)}
  size="lg"
>
<div className="approve-section edit-fields-grid">
  {approverEditableFields.map((field) => (
      <div
        className="approve-input-group"
        key={field.key}
      >
        <label>{field.label}</label>

       {field.key === "loan_product" ? (
  <select
    className="approve-input"
    value={editForm[field.key] || ""}
    onChange={(e) => {
  const productName = e.target.value;

  const product = (loanSettings?.products || []).find(
    (p) => p.product_name === productName
  );

  setEditForm((prev) => ({
    ...prev,
    loan_product: productName,
    loan_tenor: product ? String(product.min_tenure) : "",
  }));
}}
  >
    <option value="">Select loan product</option>

    {(loanSettings?.products || []).map((product) => (
      <option
        key={product.id || product.product_name}
        value={product.product_name}
      >
        {product.product_name}
      </option>
    ))}
  </select>
) : field.key === "loan_tenor" ? (
  <select
    className="approve-input"
    value={editForm.loan_tenor || ""}
    onChange={(e) =>
      setEditForm((prev) => ({
        ...prev,
        loan_tenor: e.target.value,
      }))
    }
  >
    <option value="">Select tenor</option>

    {getTenorOptions(selectedEditProduct).map((tenor) => (
      <option key={tenor} value={tenor}>
        {tenor} months
      </option>
    ))}
  </select>
) : (
<input
  className="approve-input"
  type="text"
  inputMode={field.key === "loan_amount" ? "numeric" : "text"}
  value={
    field.key === "loan_amount" && editForm[field.key]
      ? Number(String(editForm[field.key]).replace(/,/g, "")).toLocaleString()
      : editForm[field.key] || ""
  }
  onChange={(e) => {
    const value =
      field.key === "loan_amount"
        ? e.target.value.replace(/,/g, "").replace(/[^\d.]/g, "")
        : e.target.value;

    setEditForm((prev) => ({
      ...prev,
      [field.key]: value,
    }));
  }}
/>
)}

      <small style={{ color: "#64748b" }}>
  Former: {
    field.key === "loan_amount" && selectedLoan?.[field.key]
      ? Number(selectedLoan[field.key]).toLocaleString()
      : selectedLoan?.[field.key] || "-"
  }
</small>
      </div>
    ))}

    <div className="modal-actions">
      <button
        className="btn-outline"
        onClick={() => setEditModal(false)}
      >
        Cancel
      </button>

    <button
  className="btn-success"
  onClick={handleSaveFieldUpdates}
  disabled={actionLoading}
>
  {actionLoading ? (
    <span className="btn-spinner"></span>
  ) : (
    "Save Changes"
  )}
</button>
    </div>
  </div>
</BaseModal>


<BaseModal
  isOpen={payslipModalOpen}
  title="Customer Payslip"
  onClose={() => setPayslipModalOpen(false)}
  size="lg"
>
  {payslipData && (
    <div className="payslip-modal-content">
      <div className="payslip-summary">
        <div>
          <span>Month</span>
          <strong>{payslipData.month}</strong>
        </div>

        <div>
          <span>Uploaded</span>
          <strong>
            {new Date(payslipData.uploaded_at).toLocaleString()}
          </strong>
        </div>
      </div>

      <div className="payslip-scroll">
        <table className="payslip-table">
          <tbody>
            {Object.entries(payslipData.payload || {}).map(([key, value]) => (
              <tr key={key}>
                <td className="label-col">{key}</td>
                <td className="value-col">{value || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )}
</BaseModal>

<BaseModal
  isOpen={scheduleModal}
  title="Repayment Schedule"
  onClose={() => setScheduleModal(false)}
  size="lg"
>
  {selectedLoan?.schedule && (
    <div className="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Month</th>
            <th>Due Date</th>
            <th>Amount</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody>
          {[...selectedLoan.schedule]
            .sort(
              (a, b) =>
                new Date(a.due_date) -
                new Date(b.due_date)
            )
            .map((row, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{row.month || "-"}</td>
                <td>{row.due_date || "-"}</td>
                <td>
                  ₦{Number(row.amount || 0).toLocaleString()}
                </td>
                <td>
                  {row.status || (row.paid ? "Paid" : "Unpaid")}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  )}
</BaseModal>

  </>
)}
    </div>
  );
}
